import { Link } from "react-router-dom";
import { ArrowRight, ScrollText, BadgeCheck } from "lucide-react";

/**
 * Cross-sell strip for the /entry-exams page. Use on program pages where
 * an entrance exam is typically required (Bachelor, Medicine & Dentistry).
 *
 * Props:
 *   - context: opening sentence (e.g. "Medicine & Dentistry programs require")
 *   - note: short qualifier ("competitive — required for everyone")
 */
export default function EntryExamCrossSell({
  context = "Most international applicants will sit",
  note = "Required for non-OECD applicants — often required for everyone.",
  testId = "entry-exam-cross-sell",
}) {
  return (
    <section className="py-16" data-testid={testId}>
      <div className="container-sp">
        <div className="relative overflow-hidden rounded-2xl border border-[#1B2A3D] bg-[#0D1B2A] text-white grid md:grid-cols-12 gap-6 items-center p-7 md:p-10">
          <div
            aria-hidden
            className="absolute -bottom-16 -left-16 w-72 h-72 rounded-full blur-3xl opacity-30"
            style={{ background: "radial-gradient(circle, #D7141A 0%, transparent 70%)" }}
          />

          <div className="md:col-span-7 relative">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[11px] font-semibold tracking-[0.18em] uppercase text-[#E5444A]">
              <ScrollText className="w-3.5 h-3.5" /> Entry exam at a glance
            </div>
            <h3 className="font-serif text-2xl md:text-3xl text-white mt-4 leading-tight">
              {context} an <span className="text-[#E5444A]">entrance exam</span>.
            </h3>
            <p className="text-sm text-white/70 mt-3 leading-relaxed max-w-lg">
              Universities use it to rank applicants and allocate limited
              seats. We'll show you who needs to take it, why it matters, and
              recommended prep courses.
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-xs text-white/85">
              <span className="inline-flex items-center gap-1.5">
                <BadgeCheck className="w-3.5 h-3.5 text-[#E5444A]" /> {note}
              </span>
            </div>
          </div>

          <div className="md:col-span-5 relative flex md:justify-end">
            <Link
              to="/entry-exams"
              className="btn-gold"
              data-testid={`${testId}-cta`}
            >
              See Entry Exam Guide <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
